/* ============================================================
   LUDIVINA LUGO — SHOPIFY THEME JS
   ============================================================ */

/* ---------- Header: hide on scroll down ---------- */
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  let lastY = 0;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y > lastY && y > 80) {
      header.classList.add('hidden');
    } else {
      header.classList.remove('hidden');
    }
    lastY = y;
  }, { passive: true });
})();

/* ---------- Mobile menu toggle ---------- */
(function () {
  const btn = document.querySelector('.menu-btn');
  const menu = document.querySelector('.mobile-menu');
  const iconOpen = document.querySelector('.icon-menu');
  const iconClose = document.querySelector('.icon-close');
  if (!btn || !menu) return;

  btn.addEventListener('click', () => {
    const isOpen = menu.classList.toggle('open');
    if (iconOpen) iconOpen.style.display = isOpen ? 'none' : 'block';
    if (iconClose) iconClose.style.display = isOpen ? 'block' : 'none';
  });

  // close on nav link click
  menu.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      menu.classList.remove('open');
      if (iconOpen) iconOpen.style.display = 'block';
      if (iconClose) iconClose.style.display = 'none';
    });
  });
})();

/* ---------- Smooth scroll for anchor links ---------- */
document.addEventListener('click', function (e) {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const id = a.getAttribute('href').slice(1);
  const target = document.getElementById(id);
  if (target) {
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
  }
});

/* ---------- Product Carousel ---------- */
(function () {
  const section = document.querySelector('.carousel-track');
  if (!section) return;

  const items = Array.from(section.querySelectorAll('.carousel-item'));
  const total = items.length;
  if (total === 0) return;

  let active = 0;

  const isMobile = () => window.innerWidth < 768;

  function getOffset(index) {
    let diff = index - active;
    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;
    return diff;
  }

  function render() {
    const offsetX = isMobile() ? 130 : 220;
    const activeScale = isMobile() ? 1.05 : 1.15;

    items.forEach((item, i) => {
      const offset = getOffset(i);
      const isActive = offset === 0;
      const visible = Math.abs(offset) <= 2;

      item.style.display = visible ? '' : 'none';
      item.style.transform = `translateX(${offset * offsetX}px) scale(${isActive ? activeScale : 0.7})`;
      item.style.zIndex = isActive ? 10 : 5 - Math.abs(offset);
      item.style.opacity = isActive ? 1 : Math.abs(offset) === 1 ? 0.4 : 0.15;

      // name & price visibility
      const nameEl = item.querySelector('.carousel-item-name');
      const priceEl = item.querySelector('.carousel-item-price');
      const imgWrap = item.querySelector('.carousel-img-wrap');
      const overlay = item.querySelector('.carousel-overlay');

      if (nameEl) nameEl.style.opacity = isActive ? 1 : 0;
      if (priceEl) priceEl.style.opacity = isActive ? 1 : 0;

      if (imgWrap) {
        if (isActive) {
          imgWrap.classList.add('active');
        } else {
          imgWrap.classList.remove('active');
        }
      }
      if (overlay) overlay.style.display = isActive ? 'none' : 'block';
    });
  }

  function prev() { active = (active - 1 + total) % total; render(); }
  function next() { active = (active + 1) % total; render(); }

  // Click items to focus
  items.forEach((item, i) => {
    item.addEventListener('click', () => {
      active = i;
      render();
    });
  });

  // Controls
  const prevBtn = document.querySelector('.carousel-prev');
  const nextBtn = document.querySelector('.carousel-next');
  if (prevBtn) prevBtn.addEventListener('click', prev);
  if (nextBtn) nextBtn.addEventListener('click', next);

  // Touch swipe
  let touchStartX = 0;
  section.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  section.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); }
  });

  window.addEventListener('resize', render);
  render();
})();

/* ---------- Shop Collection Filter ---------- */
(function () {
  const filterBtns = document.querySelectorAll('.filter-btn');
  const productCards = document.querySelectorAll('#products-grid .product-card');
  const noMsg = document.getElementById('no-products-msg');
  if (!filterBtns.length) return;

  function applyFilter(tag) {
    filterBtns.forEach(b => {
      b.classList.toggle('active', b.dataset.tag === tag);
    });
    let visible = 0;
    productCards.forEach(card => {
      const tags = (card.getAttribute('data-tags') || '').split(',');
      const show = tag === '' || tags.indexOf(tag) !== -1;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    if (noMsg) noMsg.style.display = visible === 0 ? '' : 'none';
  }

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => applyFilter(btn.dataset.tag));
  });

  applyFilter('');
})();

/* ---------- Cart Drawer ---------- */
(function () {
  // Cart state stored in localStorage
  function getCart() {
    try { return JSON.parse(localStorage.getItem('ll_cart') || '[]'); } catch { return []; }
  }
  function saveCart(cart) {
    localStorage.setItem('ll_cart', JSON.stringify(cart));
    updateCartUI(cart);
  }

  function updateCartUI(cart) {
    const count = cart.reduce((s, i) => s + i.quantity, 0);
    // Update all badge elements
    document.querySelectorAll('.cart-badge').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    renderCartItems(cart);
  }

  function renderCartItems(cart) {
    const itemsEl = document.querySelector('.cart-items');
    const emptyEl = document.querySelector('.cart-empty');
    const footerEl = document.querySelector('.cart-footer');
    if (!itemsEl) return;

    if (cart.length === 0) {
      if (emptyEl) emptyEl.style.display = 'flex';
      if (footerEl) footerEl.style.display = 'none';
      itemsEl.innerHTML = '';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'flex';

    itemsEl.innerHTML = cart.map(item => `
      <div class="cart-item" data-slug="${item.slug}">
        <img class="cart-item-img" src="${item.image}" alt="${item.name}" />
        <div class="cart-item-info">
          <p class="cart-item-name">${item.name}</p>
          <p class="cart-item-price">${item.price}</p>
          <div class="cart-item-controls">
            <div class="cart-qty">
              <button class="qty-minus" data-slug="${item.slug}" aria-label="Reducir">
                <svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
              </button>
              <span>${item.quantity}</span>
              <button class="qty-plus" data-slug="${item.slug}" aria-label="Aumentar">
                <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              </button>
            </div>
            <button class="cart-remove" data-slug="${item.slug}" aria-label="Eliminar">
              <svg viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
            </button>
          </div>
        </div>
      </div>
    `).join('');

    // Subtotal
    const subtotalEl = document.querySelector('.cart-subtotal span:last-child');
    if (subtotalEl) {
      const total = cart.reduce((s, i) => {
        const price = parseFloat(i.price.replace(/[^0-9.]/g, ''));
        return s + price * i.quantity;
      }, 0);
      subtotalEl.textContent = '$' + total.toFixed(2);
    }

    // Re-bind controls
    itemsEl.querySelectorAll('.qty-minus').forEach(btn => {
      btn.addEventListener('click', () => changeQty(btn.dataset.slug, -1));
    });
    itemsEl.querySelectorAll('.qty-plus').forEach(btn => {
      btn.addEventListener('click', () => changeQty(btn.dataset.slug, 1));
    });
    itemsEl.querySelectorAll('.cart-remove').forEach(btn => {
      btn.addEventListener('click', () => removeItem(btn.dataset.slug));
    });
  }

  function changeQty(slug, delta) {
    const cart = getCart();
    const idx = cart.findIndex(i => i.slug === slug);
    if (idx === -1) return;
    cart[idx].quantity += delta;
    if (cart[idx].quantity <= 0) cart.splice(idx, 1);
    saveCart(cart);
  }

  function removeItem(slug) {
    const cart = getCart().filter(i => i.slug !== slug);
    saveCart(cart);
  }

  // Add to cart from product detail page
  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', () => {
      const slug = addToCartBtn.dataset.slug;
      const name = addToCartBtn.dataset.name;
      const price = addToCartBtn.dataset.price;
      const image = addToCartBtn.dataset.image;

      const cart = getCart();
      const existing = cart.find(i => i.slug === slug);
      if (existing) {
        existing.quantity++;
      } else {
        cart.push({ slug, name, price, image, quantity: 1 });
      }
      saveCart(cart);
      showToast('¡Añadido al carrito!');
      openCartDrawer();
    });
  }

  // Open/close drawer
  function openCartDrawer() {
    document.querySelector('.cart-drawer')?.classList.add('open');
    document.querySelector('.cart-overlay')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    document.querySelector('.cart-drawer')?.classList.remove('open');
    document.querySelector('.cart-overlay')?.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.cart-btn').forEach(btn => {
    btn.addEventListener('click', openCartDrawer);
  });
  document.querySelector('.cart-close')?.addEventListener('click', closeCartDrawer);
  document.querySelector('.cart-overlay')?.addEventListener('click', closeCartDrawer);

  // Checkout button placeholder
  document.querySelector('.cart-checkout')?.addEventListener('click', () => {
    showToast('Procesando tu pedido…');
  });

  // Init
  updateCartUI(getCart());
})();

/* ---------- Toast ---------- */
function showToast(msg) {
  const container = document.querySelector('.toast-container');
  if (!container) return;
  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.textContent = msg;
  container.appendChild(toast);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => toast.classList.add('show'));
  });
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

/* ---------- Newsletter forms ---------- */
document.querySelectorAll('.newsletter-form').forEach(form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const input = form.querySelector('input[type="email"]');
    if (!input || !input.value) return;
    showToast('¡Bienvenida a la luz angelical!');
    input.value = '';
  });
});
